module.exports = __webpack_public_path__ + "img/perm_contact_calendar.91ea05e0.svg";